import {
  PurchaseOrderStage,
  DeliveryShippingSubStage,
} from '../../Constants/purchase-order-status';
import { PurchaseOrder } from '../../Types/purchase-order';

export function isPoAsnEligible(
  purchaseOrder: PurchaseOrder,
  generateAsnEnabled: boolean,
): boolean {
  return (
    generateAsnEnabled &&
    purchaseOrder.stage === PurchaseOrderStage.DELIVERY_SHIPPING &&
    purchaseOrder.sub_stage === DeliveryShippingSubStage.PENDING
  );
}
